/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_LabelInputs */

const en_how_we_work_label = /** @type {(inputs: How_We_Work_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How we work`)
};

const lv_how_we_work_label = /** @type {(inputs: How_We_Work_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kā mēs strādājam`)
};

/**
* | output |
* | --- |
* | "How we work" |
*
* @param {How_We_Work_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_label = /** @type {((inputs?: How_We_Work_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_label(inputs)
	return en_how_we_work_label(inputs)
});